import React from "react";

import Heading from "@common/components/Heading/Heading";
import * as Styled from "@main/pages/Administration/components/TeamMembersCard/TeamMemberHeaders/TeamMembersGroupHeader.styles";

interface TeamMemberGroupHeaderProps {
  title: string;
  color1: string;
  color2?: string;
}

export const TeamMemberGroupHeader = ({ title, color1, color2 }: TeamMemberGroupHeaderProps) => {
  return (
    <Styled.TeamMembersHeader>
      <Styled.CirclesWrap>
        <Styled.Circle color={color1} />
        {color2 ? (
          <Styled.Circle
            color={color2}
            style={{ marginLeft: "-0.5rem" }}
          />
        ) : null}
      </Styled.CirclesWrap>
      <Heading
        fontWeight={"bold"}
        marginBottom={0}
        heading4
      >
        {title}
      </Heading>
    </Styled.TeamMembersHeader>
  );
};
